import React from 'react';

export default function About() {
  return (
    <div className="bg-slate-950 text-slate-100 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto space-y-12">
        <div className="text-center">
          <span className="text-xs font-black uppercase tracking-widest px-3 py-1 bg-blue-950 text-blue-400 rounded-full border border-blue-900/50">
            About AssuranceTech Innovation
          </span>
          <h1 className="text-4xl sm:text-5xl font-black text-white mt-4 mb-4">Empowering Minds Through Technology</h1>
          <p className="text-slate-400 text-base leading-relaxed">
            AssuranceTech Innovation is a technology company focused on designing intelligent educational, professional, and faith-based applications that create lasting impact.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-slate-900 p-8 rounded-3xl border border-slate-800">
            <h3 className="text-2xl font-black text-white mb-3">Our Vision</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              We envision a world where technology is not merely a tool for convenience but a catalyst for meaningful transformation across academic, professional, and spiritual growth.
            </p>
          </div>
          <div className="bg-slate-900 p-8 rounded-3xl border border-slate-800">
            <h3 className="text-2xl font-black text-white mb-3">Our Mission</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              To develop innovative digital solutions that empower people to learn, grow, lead, and thrive by combining education, healthcare, technology, and faith.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}